import React from 'react';
import { FaCheck, FaMinusCircle } from 'react-icons/fa';

import {
	PASSWORD_LOWERCASE,
	PASSWORD_MAX_LENGTH,
	PASSWORD_MIN_LENGTH,
	PASSWORD_NUMBER,
	PASSWORD_SPECIAL,
	PASSWORD_UPPERCASE,
} from './schemas/schema-errors';

type PasswordValidationMessagesProps = {
	password: string;
};

export const PasswordValidationMessages: React.FC<
	PasswordValidationMessagesProps
> = ({ password }) => {
	const validations = [
		{ isValid: password.length >= 8, message: PASSWORD_MIN_LENGTH },
		{ isValid: password.length <= 50, message: PASSWORD_MAX_LENGTH },
		{ isValid: /[A-Z]/.test(password), message: PASSWORD_UPPERCASE },
		{ isValid: /[a-z]/.test(password), message: PASSWORD_LOWERCASE },
		{ isValid: /[0-9]/.test(password), message: PASSWORD_NUMBER },
		{ isValid: /\W/.test(password), message: PASSWORD_SPECIAL },
	];

	return (
		<ul className="text-sm mb-5">
			{validations.map(({ isValid, message }, idx) => (
				<li
					key={idx}
					className={`flex items-center gap-2 ${
						isValid ? 'text-purpleBrand-500' : 'text-red-500'
					}`}
				>
					{isValid ? <FaCheck /> : <FaMinusCircle />}
					{message}
				</li>
			))}
		</ul>
	);
};
